import React, { Component } from 'react';

// reactstrap components
// import { Button } from "reactstrap";

class FixedPlugin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: 'dropdown show-dropdown',
    };
  }
  componentDidMount() {
    let mode = localStorage.getItem('mode');
    if (mode) {
      if (mode === 'light') {
        document.body.classList.add('white-content');
      } else {
        document.body.classList.remove('white-content');
      }
    }
  }
  handleClick = () => {
    if (this.state.classes === 'dropdown show-dropdown') {
      this.setState({ classes: 'dropdown show-dropdown show' });
    } else {
      this.setState({ classes: 'dropdown show-dropdown' });
    }
  };
  activateMode = (mode) => {
    switch (mode) {
      case 'light':
        localStorage.setItem('mode', 'light');
        document.body.classList.add('white-content');
        break;
      default:
        localStorage.setItem('mode', 'dark');
        document.body.classList.remove('white-content');
        break;
    }
  };
  render() {
    return (
      <div className="fixed-plugin">
        <div className={this.state.classes}>
          <div onClick={this.handleClick}>
            <i className="fa fa-cog fa-2x" />
          </div>
          <ul className="dropdown-menu show">
            <li className="header-title">PERSONALIZE THEME</li>
            <li className="adjustments-line">
              <div className="badge-colors text-center">
                <span
                  className={
                    this.props.bgColor === 'primary'
                      ? 'badge filter badge-primary active'
                      : 'badge filter badge-primary'
                  }
                  data-color="primary"
                  onClick={() => {
                    this.props.handleBgClick('primary');
                  }}
                />
                <span
                  className={
                    this.props.bgColor === 'blue'
                      ? 'badge filter badge-info active'
                      : 'badge filter badge-info'
                  }
                  data-color="blue"
                  onClick={() => {
                    this.props.handleBgClick('blue');
                  }}
                />
                <span
                  className={
                    this.props.bgColor === 'green'
                      ? 'badge filter badge-success active'
                      : 'badge filter badge-success'
                  }
                  data-color="green"
                  onClick={() => {
                    this.props.handleBgClick('green');
                  }}
                />
              </div>
            </li>
            <li className="adjustments-line text-center color-change">
              <span className="color-label">LIGHT MODE</span>
              <span
                className="badge light-badge mr-2"
                onClick={() => this.activateMode('light')}
              />
              <span
                className="badge dark-badge ml-2"
                onClick={() => this.activateMode('dark')}
              />
              <span className="color-label">DARK MODE</span>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default FixedPlugin;
